import {createSlice} from "@reduxjs/toolkit";
import { getProductData, createProduct, deleteProduct, getProductById, updateProduct } from './thunk'

export const initialState = {
    productList: {
        content:[]
    },
    product:{},
    errors: {}
};

const ProductSlice = createSlice({
    name: "product",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getProductData.fulfilled, (state: any, action: any) => {
            state.productList = action.payload;
        });
        builder.addCase(getProductData.rejected, (state: any, action: any) => {
            state.error = action.payload.error || null;
        });

        builder.addCase(createProduct.fulfilled, (state: any, action: any) => {
            const stateCurrent = state.productList
            stateCurrent.content.unshift(action.payload);
        });
        builder.addCase(createProduct.rejected, (state: any, action: any) => {
            state.error = action.payload.error || null;
        });

        builder.addCase(deleteProduct.fulfilled, (state: any, action: any) => {
            state.productList.content = state.productList.content.filter(
                (product: any) => product.id !== action.payload);
        });
        builder.addCase(deleteProduct.rejected, (state: any, action: any) => {
            state.error = action.payload.error || null;
        });

        builder.addCase(getProductById.fulfilled, (state: any, action: any) => {
            state.product = action.payload;
        });
        builder.addCase(getProductById.rejected, (state: any, action: any) => {
            state.error = action.payload || null;
        });

        builder.addCase(updateProduct.fulfilled, (state: any, action: any) => {
            state.product = action.payload
        });
        builder.addCase(updateProduct.rejected, (state: any, action: any) => {
            state.error = action.payload.error || null;
        });
    }

});

export default ProductSlice.reducer;
